<template>
    <div
        :style="{ borderColor: borderColor }"
        class="section-selector"
        :class="{
            '-focus': focus,
            '-disabled': section.disabled || disabled,
            '-success': success,
            '-error': error
        }"
    >
        <div class="input-prefix" v-if="section.prefix">
            {{ section.prefix }}
        </div>
        <input
            v-if="!isLinkified"
            :name="section.key"
            :style="{ color: textcolor }"
            ref="textInput"
            @keydown.enter="confirmInput(true)"
            autocomplete="new-password"
            @input="onInput"
            @blur="confirmInput"
            @focus="handleClick"
            :class="{
                '-prefix': section.prefix,
                '-success': success,
                '-error': error
            }"
            :placeholder="placeholder"
            :type="inputType"
            :value="section.value"
            :disabled="section.disabled || disabled"
        />
        <div
            v-else
            class="linkified"
            v-linkified
            v-text="section.value"
            @click="focusLinkified"
        />
        <div class="input-prefix" v-if="section.suffix">
            {{ section.suffix }}
        </div>
    </div>
</template>
<script>
export default {
    props: {
        accent: String,
        value: [String, Number],
        section: Object,
        blockBlur: Boolean,
        success: Boolean,
        error: Boolean,
        disabled: Boolean
    },
    data() {
        return {
            changesMade: false,
            focus: false,
            editing: false
        }
    },
    computed: {
        isLinkified() {
            return (
                this.section.linkified &&
                !(this.focus || this.section.value == '')
            )
        },
        textcolor() {
            return this.section.color ? this.section.color : '#333'
        },
        borderColor() {
            return this.focus ? this.$Utils.colors[this.accent] : ''
        },
        inputType() {
            switch (true) {
                case this.section.password:
                    return 'password'
                case this.section.type == 'number-input':
                    return 'number'
                default:
                    return 'text'
            }
        },
        placeholder() {
            return this.section.placeholder
                ? this.section.placeholder
                : this.$t('PLACEHOLDER_TYPE_HERE')
        }
    },
    methods: {
        focusLinkified() {
            this.focus = true
            this.$nextTick(() => {
                this.focusInput()
            })
        },
        focusInput() {
            this.$refs.textInput?.focus()
        },
        handleClick() {
            this.focus = true
            this.$emit('handleClick')
        },
        blur() {
            this.focus = false
        },
        confirmInput(entered) {
            const enter = entered === true
            this.focus = false
            if (
                this.changesMade == true &&
                (entered === true ||
                    (entered !== true &&
                        !this.blockBlur &&
                        !this.section.blockBlur))
            ) {
                this.$emit('confirmInput', this.section, enter)
            } else {
                this.$emit('blur', this.section, enter)
            }
            this.changesMade = false
        },
        onInput($event) {
            this.changesMade = true
            let value = $event.target.value
            if (value === null) {
                this.$emit('input', value)
                return
            }
            if (this.section.type == 'number-input') {
                value = value.replace(',', '.').replace(' ', '')
            }
            this.$emit('input', value)
        }
    }
}
</script>
<style lang="scss" scoped>
.section-selector {
    display: flex;
}
.input-prefix {
    margin: 0 1rem;
    color: $smoked;
    text-transform: uppercase;
}
.linkified {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0 1rem;
    font-size: 1.1rem;
    font-family:
        BlinkMacSystemFont,
        -apple-system,
        'Segoe UI',
        'Roboto',
        'Oxygen',
        'Ubuntu',
        'Cantarell',
        'Fira Sans',
        'Droid Sans',
        'Helvetica Neue',
        'Helvetica',
        'Arial',
        sans-serif;
}
</style>
